module.exports = __webpack_public_path__ + "img/caishen_1248.1650654c.png";